import React, { PropTypes, Component } from 'react';

class ShowCategoryTemplate extends Component {
  handleClick(e) {
    e.preventDefault();
  }
  render() {
    return (
      <div className="rq-image-grid">
        <a href={this.props.taxonomy.permalink} className="category-normal">
          <div>
            <h5>{this.props.taxonomy.value}</h5>
            <div className="post-text"><p>{this.props.taxonomy.description.slice(0, 100)}</p></div>
          </div>
        </a>
      </div>
    );
  }
}
ShowCategoryTemplate.propTypes = {
  'taxonomy': React.PropTypes.object,
};
ReactiveTemplateCategories['showCategoryTemplate'] = ShowCategoryTemplate;

ReactiveCategories.push({
  'key': 'showCategoryTemplate',
  'image_url': API.IMG + 'do-post-grid.jpg',
  'type': 'all',
});



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/preview/block/category/showCategoryTemplate.js
 **/